module.exports = __webpack_public_path__ + "img/symbol_6.0707a941.png";